export const documentStatuses = [
  { value: 0, text: 'pending', theme: 'warning', icon: 'Clock' },
  { value: 1, text: 'toBeVerified', theme: 'warning', icon: 'Clock' },
  {
    value: 2,
    text: 'accepted',
    theme: 'success',
    icon: 'Check'
  },
  { value: 3, text: 'rejected', theme: 'danger', icon: 'Close' },
  { value: 4, text: 'illegible', theme: 'danger', icon: 'Close' },
  { value: 5, text: 'expired', theme: 'danger', icon: 'Close' },
  { value: 6, text: 'wrongType', theme: 'danger', icon: 'Close' },
  { value: 7, text: 'wrongHolder', theme: 'danger', icon: 'Close' },
  { value: 8, text: 'duplicated', theme: 'danger', icon: 'Close' }
];

export const documentTypes = [
  { value: 1, text: 'address' },
  { value: 0, text: 'id' },
  { value: 2, text: 'bank' },
  { value: 3, text: 'passportEu' },
  { value: 4, text: 'passportNonEu' },
  { value: 5, text: 'residencePermit' },
  { value: 6, text: 'other' },
  { value: 7, text: 'companyRegistration' },
  { value: 11, text: 'driverLicense' },
  { value: 12, text: 'aoa' },
  { value: 13, text: 'selfie' },
  { value: 14, text: 'other' },
  { value: 15, text: 'other' },
  { value: 16, text: 'other' },
  { value: 17, text: 'other' },
  { value: 18, text: 'other' },
  { value: 19, text: 'other' },
  { value: 20, text: 'other' },
  { value: 21, text: 'sddMandate' }
];
